import React, { useEffect } from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../../TokenTransferStep";
import MFAPhoneVerificationCode from "./MFAPhoneVerificationCode";
import MissingPhoneNumber from "./MissingPhoneNumber";
import { useCurrentUser } from "@/libs/apis/onboarding/useUser";

export default function VerifyAccount({
  isShowing = false,
  onSuccess,
  onError,
}: TokenTransferStepProps) {
  const { currentUser } = useCurrentUser();

  // we can't add a user phone number in test so mocking as true
  const userHasNumber =
    process.env.NEXT_PUBLIC_CURRENT_ENV !== "production"
      ? true
      : !!currentUser?.contact?.sms?.verifiedNumber;

  useEffect(() => {
    if (isShowing && !userHasNumber && onError) {
      onError();
    }
  }, [isShowing, userHasNumber, onError]);

  return (
    <TokenTransferStep isShowing={isShowing}>
      {userHasNumber ? (
        <VerifyAccountView isShowing={isShowing} onSuccess={onSuccess} />
      ) : (
        <MissingPhoneNumber isShowing={isShowing} />
      )}
    </TokenTransferStep>
  );
}

function VerifyAccountView({
  isShowing = false,
  onSuccess,
}: TokenTransferStepProps) {
  return (
    <>
      <ModalHeader>Verify Account</ModalHeader>
      <ModalBody>
        <MFAPhoneVerificationCode
          isEnabled={isShowing}
          onSuccess={onSuccess as (data?: any) => Promise<void>}
        />
      </ModalBody>
    </>
  );
}
